var _path, _path2, _path3, _line, _line2, _line3, _path4, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _rect, _rect2, _circle, _circle2, _path5, _line10, _path6, _path7, _path8, _line11, _line12, _line13, _path9, _line14, _line15, _path0, _line16, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPreviewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 201,
    viewBox: "0 0 322 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.295 69.5026L314 108.5L285.474 154.985L220.758 114.981L249.295 69.5026Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 82.309L62.455 42.4706",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0987 200.148L169.5 140.809",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.829843,
    y1: 82.751,
    x2: 78.8298,
    y2: 198.751,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 63.2234,
    y1: 41.3342,
    x2: 111.223,
    y2: 52.3342,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 111.844,
    y1: 52.7721,
    x2: 167.844,
    y2: 140.772,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4274 42.0494L83 70.809",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 109.547,
    y1: 54.1459,
    x2: 83.5472,
    y2: 71.1459,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 91.9982,
    y1: 11.9395,
    x2: 93.9982,
    y2: 44.9395,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 91.8678,
    y1: 11.0088,
    x2: 166.868,
    y2: 1.00877,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 167.989,
    y1: 1.85019,
    x2: 172.989,
    y2: 34.8502,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 171.826,
    y1: 34.0152,
    x2: 205.826,
    y2: 28.0152,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 167.559,
    y1: 1.17115,
    x2: 207.559,
    y2: 28.1712,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 207.987,
    y1: 28.837,
    x2: 226.987,
    y2: 143.837,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 144.842,
    y1: 156.013,
    x2: 225.842,
    y2: 143.013,
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 90.309,
    width: 5,
    height: 54,
    rx: 2.5,
    fill: "#FB7C51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.4336,
    y: 109.38,
    width: 54,
    height: 5,
    rx: 2.5,
    transform: "rotate(6.26025 60.4336 109.38)",
    fill: "#FB7C51"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 67,
    r: 5,
    fill: "#FB7C51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 62,
    r: 5,
    fill: "#FB7C51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.978 98.3505C144.207 98.2846 142.798 96.7843 143.168 95.0516C143.973 91.2802 145.942 87.8047 148.857 85.101C152.576 81.6511 157.543 79.7259 162.716 79.7296C167.889 79.7333 172.864 81.6656 176.598 85.1208C179.521 87.8251 181.505 91.2977 182.328 95.0643C182.708 96.8019 181.295 98.3115 179.517 98.3752C177.754 98.4383 176.31 97.0421 175.799 95.3537C175.138 93.1694 173.891 91.1686 172.159 89.5652C169.622 87.2185 166.243 85.906 162.73 85.9035C159.216 85.901 155.842 87.2086 153.317 89.5518C151.597 91.1474 150.361 93.1386 149.708 95.3136C149.198 97.0105 147.748 98.4164 145.978 98.3505Z",
    fill: "#FB7C51"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 209.666,
    y1: 34.6284,
    x2: 219.666,
    y2: 25.6284,
    stroke: "#FB7C51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5 25L247 52",
    stroke: "#FB7C51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209 29L221 17.5",
    stroke: "#FB7C51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.343 17.6362L256.5 52",
    stroke: "#FB7C51"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 211.971,
    y1: 54.5009,
    x2: 279.971,
    y2: 50.5009,
    stroke: "#FB7C51"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 213.958,
    y1: 61.5017,
    x2: 273.958,
    y2: 56.5017,
    stroke: "#FB7C51"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 279.499,
    y1: 49.9688,
    x2: 281.499,
    y2: 81.9688,
    stroke: "#FB7C51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274 56L275.5 78.5",
    stroke: "#FB7C51"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 193.251,
    y1: 150.568,
    x2: 267.251,
    y2: 193.568,
    stroke: "#FB7C51"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 266.574,
    y1: 193.738,
    x2: 320.574,
    y2: 105.738,
    stroke: "#FB7C51"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M219.585 105.72L247.5 62",
    stroke: "#FB7C51"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 247.256,
    y1: 61.5702,
    x2: 321.256,
    y2: 105.57,
    stroke: "#FB7C51"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M226 143.5L223.5 130L221 115L285.5 154.787L274 173.287L226 143.5Z",
    fill: "#FB7C51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 128.5L259 105C259 105 266.931 102.344 273 106.5C276.979 109.224 278.5 116 278.5 116L267 145.5L237.5 128.5Z",
    fill: "#FB7C51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.742 128.005C274.212 128.238 274.605 128.554 274.962 128.927C275.318 129.3 275.599 129.727 275.788 130.183C275.976 130.639 276.069 131.116 276.06 131.586C276.052 132.055 275.943 132.509 275.739 132.921C275.535 133.333 275.24 133.695 274.871 133.986C274.503 134.277 274.067 134.492 273.59 134.619C273.113 134.745 272.604 134.78 272.091 134.722C271.578 134.665 271.072 134.515 270.601 134.282L272.154 131.145L273.742 128.005Z",
    fill: "#FB7C51"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.285 118.037C247.851 117.742 247.505 117.376 247.203 116.957C246.9 116.539 246.68 116.078 246.556 115.6C246.431 115.123 246.404 114.638 246.477 114.174C246.549 113.71 246.719 113.275 246.978 112.895C247.236 112.515 247.577 112.196 247.982 111.958C248.387 111.72 248.848 111.566 249.338 111.506C249.827 111.446 250.337 111.481 250.837 111.608C251.338 111.735 252.066 112.205 252.5 112.5L250.286 115.143L248.285 118.037Z",
    fill: "#FB7C51"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 62L232.5 60L250.5 58.5L247.5 61.5L245 65L241 72L237 78L232.001 86.3786L221 103L214.5 62Z",
    fill: "#FB7C51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M274 57L275.001 77.4999L247 61.5L247 59L250 59L251.717 58.7222L256.5 58L262.5 57.5L268 57L274 57Z",
    fill: "#FB7C51"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220 26L246.194 51.9615L213.713 54.2115L210 35L220 26Z",
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPreviewIcon);
export default __webpack_public_path__ + "static/media/noPreviewIcon.e62ed26803474ce6bdbe3a10f622a141.svg";
export { ForwardRef as ReactComponent };